import { AfterViewInit, Component, ElementRef, OnInit } from '@angular/core';
import { UtilService } from './services/util.service';
import { NavigationEnd, Router } from '@angular/router';
import { Constants } from './constants/constants';
import { PrimeNGConfig } from 'primeng/api';
import esLocale from 'primelocale/es.json';
import { AutenticacionService } from './modules/auth/services/autenticacion.service';
import { PushNotificationService } from './services/push-notification.service';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { environment } from '../environments/environment';
import { LanguageService } from './services/util/language.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements AfterViewInit, OnInit {
  isSecure = environment.esHttps;
  title = 'Justifacil';
  public isLoggedIn = false;
  private token!: string | null;
  isDarkMode = false;
  public SuperAdministrador = 'Superadministrador';
  public role = '';
  isCollapsed = false;

  constructor(
    private utilService: UtilService,
    private autenticacionService: AutenticacionService,
    private router: Router,
    private ref: ElementRef,
    private primeNgConfig: PrimeNGConfig,
    /* inject the gtmService in your controller */
    private gtmService: GoogleTagManagerService,
    private authService: AutenticacionService,
    private languageService: LanguageService
  ) {
    const currentLang = this.languageService.getCurrentLanguage();
    this.languageService.changeLanguage(currentLang);

    this.token = sessionStorage.getItem(Constants.IS_SUCCESS_LOGIN);
    if (this.token === '1') {
      this.utilService.showNavUser();
      const exp = localStorage.getItem('accessTokenExp');
      if (exp) {
        this.autenticacionService.scheduleRefreshFromExpiration(+exp);
      }
    }else{
      this.utilService.hideNavUser();
    }

    const userData = sessionStorage.getItem(Constants.USER_TYPE);
    if (userData) {
      const parseObject = JSON.parse(userData);
      this.role = parseObject.Nombre;
      //console.log('Rol recuperado desde sessionStorage:', this.role);
    }

    this.utilService.watchNavUser().subscribe(val => {
      this.isLoggedIn = val;
    });
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.cambiarContexto(this.isDarkMode);
      }
    });
    const mutations = new MutationObserver(e => {
      e.forEach(mutation => {
        try {
          if (mutation.addedNodes.length > 0) {
            if (mutation.addedNodes[0] instanceof HTMLElement) {
              this.cambiarAccesibilidad(
                mutation.addedNodes[0] as HTMLElement,
                'contexto'
              );
            }
          }
        } catch (error) {}
      });
    });
    const element = ref.nativeElement as HTMLElement;
    if (element?.parentNode) {
      mutations.observe(element.parentNode, {
        childList: true,
        subtree: true,
      });
      //console.log('Observando cambios en el DOM', element.parentNode);
    }
    /* recive tags without pushing events*/
    this.gtmService.addGtmToDom();
  }

  ngOnInit() {
    this.primeNgConfig.ripple = true;
    this.primeNgConfig.setTranslation({
      ...esLocale.es,
      dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'],
    });

    /*pushing events on your gtm */
    this.router.events.forEach(item => {
      if (item instanceof NavigationEnd) {
        const gtmTag = {
          event: 'page',
          pageName: item.url,
        };
        this.gtmService.pushTag(gtmTag);
      }
    });

    this.utilService.role$.subscribe(role => {
      this.role = role || '';
      //console.log('Rol actualizado desde el observable:', this.role);
    });

    const userData = sessionStorage.getItem(Constants.USER_TYPE);
    if (userData) {
      const parseObject = JSON.parse(userData);
      this.utilService.setRole(parseObject.Nombre);
    }
  }

  isLogin(): boolean {
    const isLogin = sessionStorage.getItem(Constants.IS_SUCCESS_LOGIN);
    return isLogin === '1';
  }

  showSideBar(): boolean {
    //console.log('Rol validado:', this.role);
    return this.role != 'Abogado' && this.role != 'Ciudadano' && this.isLogin();
  }

  ngAfterViewInit() {
    setTimeout(() => this.cambiarContexto(this.isDarkMode));
  }

  isSuperadministrador(): boolean {
    return this.role === Constants.TIPOS_USUARIO.SUPERADMINISTRADOR;
  }

  cambiarContexto(darkMode: boolean) {
    this.isDarkMode = darkMode;
    const element = document.getElementsByTagName('body')[0] as HTMLElement;
    this.cambiarAccesibilidad(element, 'contexto');
  }

  cambiarAccesibilidad(element: HTMLElement, tipo: string) {
    if (
      (element?.className?.includes &&
        element?.className?.includes('barra-accesibilidad-govco')) ||
      this.isSpinner(element)
    ) {
      return;
    }
    if (tipo === 'contexto') {
      if (!this.isDarkMode && element.className?.replaceAll) {
        element.className = element.className?.replaceAll(
          'modo_oscuro-govco',
          ''
        );
      } else {
        element.className = 'modo_oscuro-govco ' + element.className;
      }
    } else {
      const total = this.tamanioElemento(element);
      element.style.fontSize =
        (tipo === 'aumentar' ? total + 1 : total - 1) + 'px';
    }
    for (let i = 0; i < element.children?.length; i++) {
      this.cambiarAccesibilidad(element.children[i] as HTMLElement, tipo);
    }
  }

  tamanioElemento(element: Element) {
    const tamanioParrafo = window
      .getComputedStyle(element, null)
      .getPropertyValue('font-size');
    return parseFloat(tamanioParrafo);
  }

  disminuirTamanio() {
    const element = document.getElementsByTagName('app-root')[0] as HTMLElement;
    this.cambiarAccesibilidad(element, 'disminuir');
  }

  aumentarTamanio() {
    const element = document.getElementsByTagName('app-root')[0] as HTMLElement;
    this.cambiarAccesibilidad(element, 'aumentar');
  }

  isSpinner(element: HTMLElement): boolean {
    const flag = element?.tagName === 'NGX-SPINNER';
    if (element?.parentElement === null) {
      return flag;
    }
    return flag || this.isSpinner(element.parentElement);
  }

  toggleSidebar() {
    this.isCollapsed = !this.isCollapsed;
  }
}
